import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {

  connect() {
    this.originalUrl = window.location.href
    // Remember the modal's default width class so we can restore it for content
    // that doesn't request a specific size.
    this.defaultSizeClass = this.element.className.match(/modal-(sm|lg|xl)\b/)?.[0] || null
    this.modal = new bootstrap.Modal(this.element, { backdrop: 'static'})
    this.element.addEventListener('turbo:frame-load', (event) => {
      this.applySize()
      this.open()
    })
  }

  // Loaded content may request a width via data-modal-size on any element in the
  // frame ("regular" | "sm" | "lg" | "xl"). Absent a hint, the modal keeps its
  // default size, so existing modals are unaffected.
  applySize() {
    const hint = this.element.querySelector('[data-modal-size]')?.dataset.modalSize
    this.element.classList.remove('modal-sm', 'modal-lg', 'modal-xl')
    if (hint && hint !== 'regular') {
      this.element.classList.add(`modal-${hint}`)
    } else if (!hint && this.defaultSizeClass) {
      this.element.classList.add(this.defaultSizeClass)
    }
  }

  open() {
    this.modal.show()
  }

  close(event) {
    event.preventDefault();
    this.modal.hide()
    if (this.element.classList.contains('show')) return

    window.history.pushState({}, '', this.originalUrl);
  }

  closeAndNavigate(event) {
    // Close modal without preventing default link behavior
    this.modal.hide()
    window.history.pushState({}, '', this.originalUrl);
  }

  backdropClose(event) {
    // Only close if clicking directly on the modal backdrop
    if (event.target === this.element) {
      this.close(event)
    }
  }
}
